






































import { computed, defineComponent, ref } from "@vue/composition-api";
import useDeviceData, { Detectors } from "@/store/modules/useDeviceData";
import AttachedDeviceModel from "@/models/AttachedDeviceModel";
import { app } from "@/store/index";

export default defineComponent({
    components: {
        SensorItem: () =>
            import("./Sensors/DefaultSensorListItem.vue"),
        EnrollDialog: () =>
            import("./Dialogs/EnrollDialog.vue")
    },
    setup() {
        const { getDetectorData } = useDeviceData();
        const connectSensor = ref<AttachedDeviceModel>();
        const heatModel = computed<AttachedDeviceModel>(() => {
            return getDetectorData(Detectors.heat);
        });
        const coModel = computed<AttachedDeviceModel>(() => {
            return getDetectorData(Detectors.co);
        });
        const smokeModel = computed<AttachedDeviceModel>(() => {
            return getDetectorData(Detectors.smoke);
        });
        const waterModel = computed<AttachedDeviceModel>(() => {
            return getDetectorData(Detectors.water);
        });
        const gasModel = computed<AttachedDeviceModel>(() => {
            return getDetectorData(Detectors.gas);
        });
        const bilgePumpModel = computed<AttachedDeviceModel>(() => {
            return getDetectorData(Detectors.bilge);
        });
        const enroll = (model: AttachedDeviceModel) => {
            connectSensor.value = model;
        };

        const panel = computed<number>(() => {
            if (app.getSensorsPanelOpen) {
                console.log("app.getSensorsPanelIndex", app.getSensorsPanelIndex);
                return app.getSensorsPanelIndex;
            } else {
                console.log("app.getSensorsPanelIndex", -1);
                return -1;
            }
        });

        return {
            heatModel,
            coModel,
            smokeModel,
            waterModel,
            gasModel,
            bilgePumpModel,
            enroll,
            connectSensor,
            panel
        };
    }
});
